var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-indicator-wrapper row justify-center items-center",class:{ 'auto-height': _vm.autoHeight },style:(_vm.autoHeight ? `margin-top: ${_vm.marginTop};` : null)},[_c('div',{staticClass:"col-auto"},[_c(_vm.type ? `q-spinner-${_vm.type}` : 'q-spinner',{tag:"component",attrs:{"color":_vm.color,"size":_vm.size}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }